import { Box, Skeleton, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { FC, useEffect } from "react";
import CustomCard from "../../../components/card";
import useAppSelector from "../../../hooks/useSelector";
import net from "../../../data/network.json";
import IconsAction from "./components/iconsAction";
import {
  wrappeBox,
  wrapperError,
  wrapperMain,
  wrapperPartner,
  wrapperRoutes,
  wrapperSave,
  wrapperTitle,
} from "./routes.style";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { setSelectedExchangeData } from "../../../redux/slices/selectedExchangeSlice";
import useAppDispatch from "../../../hooks/useDispatch";
import partner from "../../../data/partner.json";
import { baseImageUrl } from "../../../config/imageUrl";

interface IProps {
  loading: boolean;
  active: number;
  setActive: any;
  price: any;
  timer: any;
  loadingSkeleton: boolean;
}

const Routes: FC<IProps> = ({
  loading,
  active,
  setActive,
  price,
  timer,
  loadingSkeleton,
}) => {
  const dispatch = useAppDispatch();
  const exchangeResData = useAppSelector((state) => state.exchangeRes);
  const { coinData } = useAppSelector((state) => state.coinSelect);
  const { netIconFrom } = useAppSelector((state) => state.netIcon);
  const { netIconTo } = useAppSelector((state) => state.netIcon);

  const handleExchangeRes = (index: number) => {
    dispatch(setSelectedExchangeData(exchangeResData.exchangeRes?.data[index]));
    setActive(index);
  };

  useEffect(() => {
    if (exchangeResData?.exchangeRes?.data?.length) {
      dispatch(
        setSelectedExchangeData(exchangeResData.exchangeRes.data[active])
      );
    }
  }, [exchangeResData, active, dispatch]);

  return (
    <Grid
      sx={{
        ...wrapperRoutes,
        background: (theme) => theme?.palette?.secondary?.main,
      }}
      className="animate__animated animate__fadeIn"
    >
      <IconsAction loading={loading} timer={timer} />
      {loadingSkeleton ? (
        <Grid pt={3} px={2}>
          <Stack spacing={1}>
            <Skeleton variant="circular" width={40} height={40} />
            <Skeleton
              variant="rectangular"
              sx={{ width: "100%" }}
              height={50}
            />
            <Skeleton variant="rounded" sx={{ width: "100%" }} height={50} />
            <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
          </Stack>
          <Stack spacing={1}>
            <Skeleton variant="circular" width={40} height={40} />
            <Skeleton
              variant="rectangular"
              sx={{ width: "100%" }}
              height={50}
            />
            <Skeleton variant="rounded" sx={{ width: "100%" }} height={50} />
            <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
          </Stack>
        </Grid>
      ) : (
        <CustomCard>
          {(exchangeResData?.exchangeRes?.data &&
            exchangeResData?.exchangeRes?.data.length < 1) ||
          exchangeResData?.exchangeRes?.min_amount === "-1" ||
          exchangeResData?.exchangeRes?.max_amount === "-1" ? (
            <Grid sx={wrapperError}>
              <span>oops!</span>
              <Typography>
                {exchangeResData?.exchangeRes?.message === "pair is not valid"
                  ? "The pair is not supported"
                  : exchangeResData?.exchangeRes?.message === "minimum problem"
                  ? "The amount cannot be below " +
                    exchangeResData?.exchangeRes?.min_amount
                  : null}
              </Typography>
            </Grid>
          ) : (
            <Grid>
              <Grid>
                {exchangeResData &&
                  exchangeResData?.exchangeRes?.data.map(
                    (item: any, indexExchange: number) => {
                      return (
                        <Grid
                          sx={wrappeBox}
                          className={active === indexExchange ? "active" : ""}
                          key={indexExchange}
                          onClick={() => handleExchangeRes(indexExchange)}
                        >
                          <Grid sx={wrapperTitle}>
                            {item.tags.map((item2: any, index: number) => {
                              const isKycHoldRisk = item2 === "KYC Hold Risk";
                              return (
                                <Box
                                  className={
                                    isKycHoldRisk ? "kyc_item" : "tag_item"
                                  }
                                  key={index}
                                >
                                  {item2}
                                  <Typography sx={wrapperSave}>
                                    {item2 === "Recommended" ||
                                    item2 === "Best Rate" ? (
                                      <>
                                        {(
                                          ((exchangeResData?.exchangeRes?.data[
                                            indexExchange
                                          ]?.amount -
                                            exchangeResData?.exchangeRes?.data[
                                              exchangeResData?.exchangeRes?.data
                                                .length - 1
                                            ].amount) /
                                            exchangeResData?.exchangeRes?.data[
                                              indexExchange
                                            ].amount) *
                                          100
                                        ).toFixed(2)}
                                        % Saved
                                      </>
                                    ) : null}
                                  </Typography>
                                </Box>
                              );
                            })}
                          </Grid>
                          <Grid sx={wrapperMain} pt={3}>
                            <Grid>
                              <Typography variant="h4">
                                {item.amount} 
                                {coinData[1]?.symbol.toUpperCase()}
                              </Typography>
                              <Grid my={2} container>
                                <Typography mt={-0.3}>
                                  {item.partner_name}
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid>
                              <Typography>
                                $~{" "}
                                {(price * item.amount).toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              </Typography>
                              <Typography
                                style={{ fontWeight: "700" }}
                                sx={{
                                  color: (theme) =>
                                    theme?.palette?.primary?.main,
                                  marginTop: {},
                                }}
                              >
                                CEX -
                                <img
                                  style={{
                                    width: "17px",
                                    position: "relative",
                                    top: "3px",
                                  }}
                                  src={
                                    item?.exchange_type === "floating"
                                      ? "/assets/images/routes/float.svg"
                                      : "/assets/images/routes/fixed.png"
                                  }
                                />
                                {item?.exchange_type}
                              </Typography>
                            </Grid>
                          </Grid>
                          {active === indexExchange && (
                            <Grid
                              sx={wrapperPartner}
                              className="animate__animated animate__fadeIn"
                            >
                              <Grid>
                                <Typography
                                  style={{ position: "relative" }}
                                  pt={1}
                                >
                                  <img
                                    src={
                                      coinData[0]?.image
                                        ? coinData[0].image.startsWith("http")
                                          ? coinData[0].image
                                          : `${baseImageUrl}/${coinData[0].image}`
                                        : "./assets/images/coins/noPic.svg"
                                    }
                                    width="22px"
                                    height="22px"
                                    style={{ borderRadius: "50%" }}
                                  />{" "}
                                  <img
                                    alt="flashift"
                                    src={
                                      netIconFrom
                                        ? netIconFrom
                                        : `${baseImageUrl}/${
                                            net.filter(
                                              (item) =>
                                                item?.name.toUpperCase() ===
                                                coinData[0]?.network.toUpperCase()
                                            )?.[0]?.image
                                          }`
                                    }
                                    width="15.5px"
                                    height="15.5px"
                                    className="netIcon"
                                    style={{ left: "55px", top: "13px" }}
                                  />
                                </Typography>
                              </Grid>
                              <Grid
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-around",
                                  position: "relative",
                                  top: "9px",
                                }}
                              >
                                <ArrowRightAltIcon />
                                <Grid>
                                  <img
                                    src={`${baseImageUrl}/${
                                      partner.filter(
                                        (src) =>
                                          src?.name === item?.partner_name
                                      )?.[0]?.image_small
                                    }`}
                                    alt="flashift"
                                    height="24px"
                                  />
                                </Grid>
                                <ArrowRightAltIcon />
                              </Grid>
                              <Grid>
                                <Typography
                                  style={{ position: "relative" }}
                                  pt={1}
                                >
                                  <img
                                    src={
                                      coinData[1]?.image
                                        ? coinData[1].image.startsWith("http")
                                          ? coinData[1].image
                                          : `${baseImageUrl}/${coinData[1].image}`
                                        : "./assets/images/coins/noPic.svg"
                                    }
                                    width="22px"
                                    height="22px"
                                    style={{ borderRadius: "50%" }}
                                  />

                                  <img
                                    alt="flashift"
                                    src={
                                      netIconTo
                                        ? netIconTo
                                        : `${baseImageUrl}/${
                                            net.filter(
                                              (item) =>
                                                item?.name.toUpperCase() ===
                                                coinData[1]?.network.toUpperCase()
                                            )?.[0]?.image
                                          }`
                                    }
                                    width="15.5px"
                                    height="15.5px"
                                    className="netIcon"
                                    style={{ left: "55px", top: "13px" }}
                                  />
                                </Typography>
                              </Grid>
                            </Grid>
                          )}
                        </Grid>
                      );
                    }
                  )}
              </Grid>
            </Grid>
          )}
        </CustomCard>
      )}
    </Grid>
  );
};
export default Routes;
